import React, { FC, useMemo } from 'react';
import { EventData, Joyride, Locale, Step } from 'react-joyride';
import { useTranslation } from 'react-i18next';

interface Props {
  run: boolean;
  steps: Step[];
  onEvent: (data: EventData) => void;
}

export const DashboardTours: FC<Props> = ({ run, steps, onEvent }: Props) => {
  const { t } = useTranslation();
  const locale = useMemo<Locale>(
    () => ({
      back: t('dashboard_tour_back', 'Back'),
      close: t('dashboard_tour_close', 'Close'),
      last: t('dashboard_tour_finish', 'Finish'),
      next: t('dashboard_tour_next', 'Next'),
      nextWithProgress: t('dashboard_tour_next_with_progress', 'Next ({current} of {total})'),
      open: t('dashboard_tour_open', 'Open the dialog'),
      skip: t('dashboard_tour_skip', 'Skip'),
    }),
    [t]
  );

  return (
    <Joyride
      continuous
      locale={locale}
      run={run}
      scrollToFirstStep
      steps={steps}
      onEvent={onEvent}
      options={{
        primaryColor: '#0891b2',
        zIndex: 2000,
      }}
      styles={{
        buttonPrimary: {
          backgroundColor: '#0891b2',
          color: '#ffffff',
        },
      }}
    />
  );
};
